module.exports = __webpack_public_path__ + "img/JOC_3623.644ef4dd.jpg";